// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".summary-port-element .v-input input{padding-top:3px!important;width:3.9rem!important}.summary-port-element .v-icon{padding-top:2px!important}.summary-port-element .v-icon.edit-icon{font-size:11px!important;opacity:0}.summary-port-element:hover .v-icon.edit-icon{opacity:1}.summary-port-element--open{color:#2e8f45!important}.summary-port-element--closed{color:#cf2233!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
